<template>
    <div id="demov">
        <a-row type="flex" justify="start">
            <a-col style="margin-left: 10px;">
                {{ $t('easyCron.Start') }}:
                <a-date-picker
                        v-model="startTime"
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder="Start Time"
                        :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                />
            </a-col>
            <a-col style="margin-left: 10px;">
                {{ $t('easyCron.Expire') }}:
                <a-date-picker
                        v-model="endTime"
                        placeholder="Expire Time"
                        format="YYYY-MM-DD HH:mm:ss"
                        :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                />
            </a-col>
        </a-row>
        <a-row>
            <easy-cron style="width: 800px;"
                       v-model="Cronvalue"
            ></easy-cron>
        </a-row>
        <a-row class="fr" style="margin-right: 10px;">
            <a-button type="primary" size="small" @click="cronSave"> {{ $t('publicLang.Save') }}</a-button>
        </a-row>
    </div>
</template>
<script>
    import EasyCron from '../../com/easy-cron'
    import moment from 'moment';
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        props:{
            editUid: ''
        },
        components:{
            EasyCron
        },
        data(){
            return{
                Cronvalue: '',
                startTime: null,
                endTime: null,
                triggerType: null,
            }
        },
        watch:{
            editUid(){
                ajax.get(api.WAVECRITEREXTENDERTRIGGER,{uid: this.editUid}).then(res=>{
                    let data = res.data.cronExperss
                    this.startTime = res.data.startTime
                    this.endTime = res.data.expiryTime
                    if(data == '' || data == undefined){
                        data =  '0 * * * * ? *'
                    }
                    this.Cronvalue = data
                })
            }
        },
        created(){
            this.$nextTick(()=>{
                ajax.get(api.WAVECRITEREXTENDERTRIGGER,{uid: this.editUid}).then(res=>{
                    let data = res.data.cronExperss
                    this.startTime = res.data.startTime
                    this.endTime = res.data.expiryTime
                    if(data == '' || data == undefined){
                        data =  '0 * * * * ? *'
                    }
                    this.Cronvalue = data
                })
            })
        },
        methods: {
            moment,
            cronSave(){
                this.$emit('emitCronVal',{
                    cronExperss: this.Cronvalue,
                    startTime: this.startTime == null ? this.startTime : moment(this.startTime).format('YYYY-MM-DD HH:mm:ss'),
                    expiryTime: this.endTime == null ? this.endTime :  moment(this.endTime).format('YYYY-MM-DD HH:mm:ss'),
                    triggerType: this.triggerType
                })
            }
        }
    }
</script>